import { messengerReducerKey, reducer } from './reducer';
import { applyActionMiddleware } from './actionDispatch';

export {
  applyActionMiddleware,
  messengerReducerKey,
  reducer
};

export * from './actions';  // eslint-disable-line
export * from './selectors';  // eslint-disable-line
